'use strict';

/* globals config */

require([
	config.relative_path + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js',
	'coverPhoto',
	'pictureCropper',
], function (Vue, coverPhoto, pictureCropper) {
	var internals = {};

	Vue.component('image-answer-edit', {
		props: ['answer', 'initData'],
		methods: {
			selectImage: function () {
				var me = this;

				internals.openSelectImage(function (imageUrl) {
					me.answer.content = imageUrl;

					me.saveFilePermissions(imageUrl);
				});
			},
		},
		template:
		'<div>' +
			'<h5>{{initData.translations.answerPicture}}</h5>' +
			'<div class="row">' +
				'<div class="col-md-4">' +
					'<div :class="{ \'image-answer-empty\': !answer.content }">' +
						'<img v-if="answer.content" :src="answer.content" alt="" style="width: 100%" />' +
					'</div>' +
				'</div>' +
				'<div class="col-md-8">' +
					'<button type="button" class="btn btn-primary" v-on:click="selectImage()">' +
						'<i class="fa fa-picture-o"></i> ' +
						'{{initData.translations.uploadImage}}' +
					'</button>' +
				'</div>' +
			'</div>' +
		'</div>',
	});

	internals.openSelectImage = function (onSuccess) {
		pictureCropper.show({
			title: '[[ideas-board:select-image]]',
			socketMethod: 'plugins.lessons.uploadPicture',
			aspectRatio: NaN,
			allowSkippingCrop: true,
			restrictImageDimension: false,
		}, onSuccess);
	};
});
